
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { ProcessAlarm } from '../../models/process-alarm';
import { ProcessAlarmBuilder } from '../../models/builders/process-alarm.builder';

const processAlarmBody = (processAlarm: ProcessAlarm) => ({
  description: processAlarm.description,
  pattern: processAlarm.pattern,
  controlHash: processAlarm.control
});

@Injectable()
export class ProcessAlarmApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }process-alarms`;
  }

  createProcessAlarm(processAlarm) {
    return this.httpClient.post(this.apiUrl, processAlarmBody(processAlarm)).pipe(map(ProcessAlarmBuilder.fromJson));
  }

  deleteProcessAlarm(processAlarm: ProcessAlarm) {
    return this.httpClient.delete(`${ this.apiUrl }/${ processAlarm.hash }`);
  }

  getProcessAlarms() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ProcessAlarmBuilder.fromList));
  }

  getProcessAlarm(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ProcessAlarmBuilder.fromJson)
      );
  }

  updateProcessAlarm(processAlarm: ProcessAlarm) {
    return this.httpClient.put(`${ this.apiUrl }/${ processAlarm.hash }`, processAlarmBody(processAlarm));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/process-alarm-api.service.ts